import * as React from "react";
import { FunctionComponent } from "react";
import { useAuth } from "./AckAuth";

const AckSignInButton: FunctionComponent = () => {
  const auth = useAuth();
  return (<button className="button is-primary is-small" onClick={() => auth.signIn()}>Log in</button>);
};

const AckSignOutButton: FunctionComponent = () => {
  const auth = useAuth();
  return (
    <button className="button is-primary is-small is-outlined"
            onClick={() => auth.signOut({ logoutParams: { returnTo: window.location.origin } })}>Log out
    </button>
  );
};

export const AckSignInOutButton: FunctionComponent = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <AckSignOutButton/> : <AckSignInButton/>;
};
